import { Injectable } from '@angular/core';
import { TextComponent } from '../../text.component';
import { ChatTableComponent } from '../../table.component';

export type ComponentType<T> = new (...args: any[]) => T;

@Injectable()
export class ComponentMappingService {
  private componentMap = new Map<string, any>([
    ['text', TextComponent],
    ['table', ChatTableComponent],

    // Add other mappings here
  ]);

  getComponent(componentName: string): ComponentType<any> | null {
    return this.componentMap.get(componentName) || null;
  }
}
